import React, { useRef } from "react";
import { ReactComponent as SadBopOutline } from "../../img/404/sadbop_outline.svg";
import { ReactComponent as SadBopFace } from "../../img/404/sadbop_face.svg";
import useMousePosition from "../../hooks/useMousePosition";
import styled from "@emotion/styled";
import { useIsDesktop } from "hooks/useDeviceType";

export const SadBop: React.FC = () => {
  const { x, y } = useMousePosition();
  const isNotDesktop = !useIsDesktop();
  const outlineRef = useRef<SVGSVGElement | null>(null);
  const faceOffsets = isNotDesktop
    ? { top: 50, left: 30 }
    : getTopLeftPercentage(outlineRef.current, x, y);

  return (
    <Container>
      <SadBopOutline ref={outlineRef} />
      <SadBopFaceContainer offsets={faceOffsets}>
        <SadBopFace />
      </SadBopFaceContainer>
    </Container>
  );
};

// Sub-components

const Container = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  margin: 0.5rem 0 1.5rem;

  @media (min-width: 412px) {
    transform: scale(1.2);
  }
`;

interface SadBopFaceContainerProps {
  offsets: { top: number; left: number };
}

const SadBopFaceContainer = styled.div<SadBopFaceContainerProps>`
  position: absolute;
  transform: translate(0, -50%);
  top: ${props => props.offsets.top}%;
  left: ${props => props.offsets.left}%;
`;

// Helpers

export function getTopLeftPercentage(
  sadBopElement: SVGSVGElement | null,
  mouseX: number | null,
  mouseY: number | null
) {
  if (sadBopElement == null || mouseX == null || mouseY == null) {
    return { top: 50, left: 30 };
  }
  const sadBopBoundingClient = sadBopElement.getBoundingClientRect();
  const topRef =
    sadBopBoundingClient.top + (sadBopBoundingClient.bottom - sadBopBoundingClient.top) / 2;
  const leftRef =
    sadBopBoundingClient.left + (sadBopBoundingClient.right - sadBopBoundingClient.left) / 2;

  const topOffset = ((mouseY - topRef) / topRef) * 50;
  const leftOffset = ((mouseX - leftRef) / leftRef) * 30;

  const minTop = 30;
  const maxTop = 66;
  const minLeft = 20;
  const maxLeft = 40;

  const top = Math.max(Math.min(50 + topOffset, maxTop), minTop);
  const left = Math.max(Math.min(30 + leftOffset, maxLeft), minLeft);

  return { top, left };
}
